import { onMounted, onUnmounted, ref } from "vue";
import { exitFullScreenMode, fullScreenModeState } from "./fullScreenMode";

/**
 * Говорит о том, что текущая страница это активный звонок
 */
export const isActiveRoom = ref(false);

export function useActiveRoomState() {
  onMounted(() => {
    isActiveRoom.value = true;
  });
  onUnmounted(() => {
    isActiveRoom.value = false;
    if(fullScreenModeState.value) {
      exitFullScreenMode()
    }
  });
}
